import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-request-consult',
  templateUrl: './request-consult.component.html',
  styleUrls: ['./request-consult.component.scss'],
})
export class RequestConsultComponent implements OnInit {

  formGroup: FormGroup;

  bitacoraEvents = [
    'Successful_Search',
    'Not_found_case',
    'undated',
  ];
  requestNumber: number;
  notFound = false;
  channel: string;
  select_doc_type: any;
  target_doc_type: any;
  client = {
    name: '',
    document: '',
  };

  requests;
  isPostlogin = false;

  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private abreCuentasService: AbreCuentasService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private parametersService: ParametersService,
    private identificationService: IdentificationService,
    private taggingService: TaggingService,
     ) {
    this.headerService.show(false, false, true);
  }

  ngOnInit() {
    this.channel = this.channelCommunicatorService.getChannelId();
    this.select_doc_type = this.parametersService.getSetting(OpEnum.DOC_TYPE);
    this.isPostlogin = this.abreCuentasService.getPostlogin();
    if (this.isPostlogin) {
      this.requests = this.abreCuentasService.getCustomerRequests();
      return;
    }
    this.formGroup = new FormGroup({
      doc_type: new FormControl('', Validators.required),
      doc_number: new FormControl('', [Validators.required]),
      requestNumber: new FormControl('',
        [Validators.required,
          Validators.minLength(6)],
      ),
    });
  }

  onPrevious() {
    this.bitacoraService.saveDataInBitacora('return');
    this.navigationService.previousStep();
  }

  doc_type_change(e: any) {
    this.notFound = false;
    const target = e.value.id;
    const max_length_input = target === '1' ? 10 : (target === '2' ? 10 : 12);
    this.formGroup.controls.doc_number.setValidators([Validators.required,
      Validators.minLength(2), Validators.maxLength(max_length_input)]);
    this.formGroup.controls.doc_number.updateValueAndValidity();
    this.target_doc_type = {
      type_input: target === '1' || target === '2' ? 'number' : 'text',
      max_length: max_length_input,
    };
  }

  reactiveInputChange() {
    this.notFound = false;
    const control = this.formGroup.controls.doc_number as FormControl;
    if (!this.target_doc_type) {
      control.setValue(control.value.replace(new RegExp(/[^\d]/), ''));
      return;
    }
    control.setValue(control.value.slice(0, this.target_doc_type.max_length));
    if (this.target_doc_type.type_input === 'number') {
      control.setValue(control.value.replace(new RegExp(/[^\d]/), ''));
    } else {
      control.setValue(control.value.replace(new RegExp(/[^A-Za-z0-9]/), ''));
    }
  }

  /**
   * Ejecuta el redireccionamiento según el código que se valida según el código de la solicitud
   */
  async next() {
    this.tagg('2');
    await this.getClientInfo();
    if (this.notFound) { return; }
    const document = `${this.formGroup.controls.doc_number.value}_${this.formGroup.controls.doc_type.value.id}`;
    this.requestNumber = this.formGroup.controls.requestNumber.value;
    this.captureService.getRequestByNumber(this.requestNumber, document)
    .then((res: any) => {
      if (res.user) {
        this.client.name = res.user.full_name;
      }
      if (res.code.startsWith('1') && res.code !== '100') {
        res.code === '142' ? this.sendBitacora(2) : this.sendBitacora(1);
        this.navigationService.navigateToGeneralInformation(res.code);
        return;
      }
      if (res.code === '100') {
        this.tagg('3');
        this.sendBitacora(1);
        this.notFound = true;
        return;
      }
      this.sendBitacora(0);
      this.setProductState(this.abreCuentasService.getRequestModel(), res.isRefused);
      this.navigationService.nextStep();
    })
    .catch(error => {
      console.error(error);
      this.navigationService.navigateToGeneralInformation('131');
    });
  }

  nextSolicitation(solicitation) {
    this.tagg('2');
    this.abreCuentasService.setRequestModel(solicitation);
    this.setProductState(solicitation);
    this.navigationService.nextStep();
  }

  setProductState(solicitation: any, isrefused: boolean = false) {
    let anacreResponse = '';
    const status = solicitation.solicitation_status;
    const phase = solicitation.solicitation_phase;
    /* istanbul ignore next */
    if (typeof solicitation.credit_analisys === 'undefined') { return; }
    const creditResponse = solicitation.credit_analisys
      .find(element => element.key === 'RESPUESTA');

    anacreResponse = creditResponse ? creditResponse.name : '';

    if (isrefused) {
      this.abreCuentasService.setTransactionStatus('Rechazado');
    } else if (phase === '10' || (phase === '04' && anacreResponse === 'APROBADO')) {
      this.abreCuentasService.setTransactionStatus('Aprobado');
    } else {
      this.abreCuentasService.setTransactionStatus('EnProceso');
    }
  }

  async getClientInfo() {
    const info = new DocumentModel();
    info.birthdate = '';
    info.document_number = this.formGroup.controls.doc_number.value;
    info.document_type = this.formGroup.controls.doc_type.value.type;
    info.firstname = '';
    info.middlename = '';
    info.primary_lastname = '';
    info.second_lastname = '';
    info.sex = '';
    this.abreCuentasService.setDocumentInfo(info);
    const resInfo = await this.identificationService.validateIfClientExists(info);
    if (resInfo.notFound) {
      this.tagg('3');
      this.notFound = true;
      return;
    }
    this.client.name = resInfo.document.first_name;
    this.client.document = resInfo.document.number;
    if (resInfo.client && !this.isPostlogin && this.channel !== CHANNEL.PORTALO.CODE) {
      this.navigationService.navigateToGeneralInformation('140');
      this.notFound = true;
    }
  }

  /**
   * Valida solo numeros y longitud del campo de número de solicitud
   */
  keyPressRequest(event): boolean {
    this.notFound = false;
    const cadena = event.key;
    const patron = /\D/;
    if (patron.test(cadena)) {
      return false;
    }
    return true;
  }

  /**
   * Envía el string de la bitacora con el resultado y los datos del usuario
   * @param event
   * @param user
   */
  sendBitacora(event: number) {
    const actualDate = new Date();
    const dateStr = this.abreCuentasService.formatDate(actualDate);
    const dateArr = dateStr.split('T');
    const bitacoraEvent =
    `${this.bitacoraEvents[event]}_${this.client.name ?
      this.client.name.replace(' ', '_')
      : ''}_${dateArr[0]}_${dateArr[0]}_${this.client.document}`;
    console.log('bitacoraEvern ', bitacoraEvent);
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
  }

  /**
   * Retorna un mensaje de error según el tipo de identificación escogida
   * @returns string
   */
  printErrorMessage() {
    switch (this.formGroup.controls.doc_type.value.id) {
      case '1':
        return this.copyService.copies.request_consult_copies.doc_num.error_cc;
      case '2':
        return this.copyService.copies.request_consult_copies.doc_num.error_ce;
      case '5':
        return this.copyService.copies.request_consult_copies.doc_num.error_pas;
      default:
        return this.copyService.copies.request_consult_copies.doc_num.error;
    }
  }

  tagg(tag_number: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes = this.taggingService.createTagChanges(tagPageName, tag_number);
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E${tag_number}customLabel`],
      };
      switch (tag_number) {
        case '2':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.button,
            position: this.isPostlogin ? EVENT.customCategory.position.center : EVENT.customCategory.position.bottom,
          };
          event.action = EVENT.customAction.click;
          break;
        case '3':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.warning,
            position: EVENT.customCategory.position.top,
          };
          event.action = EVENT.customAction.show;
          event.errorName = this.navigationService.camelize(this.copyService.copies.request_consult_copies.not_found_label);
          break;
      }
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error en ${error}`);
    }
  }

  formatDate(date: string) {
    const mydate = new Date(date);
    let day = mydate.getDate().toString();
    let month = (mydate.getMonth() + 1).toString();
    const year = mydate.getFullYear();
    if (+day < 10) {
      day = `0${day}`;
    }
    if (+month < 10) {
      month = `0${month}`;
    }
    return `${day}/${month}/${year}`;
    // return date ? date.split('T')[0].replace(new RegExp('-', 'g'), '/') : '';
  }
}
